<template>
  <div v-if="false"></div>
</template>

<script>
import { chrome } from "window";
import env from "@/lib/env";
import store from "@/lib/store";
import { jiminnyHost } from "@/helpers/region";
import EventBus from "@/lib/event-bus";
import installPusher from "@/plugins/pusher";
import initLogRocket from "@/plugins/logrocket";

export default {
  computed: {
    userChannelName() {
      return `private-user.${store.get("user").id}`;
    },
    teamChannelName() {
      return `private-team.${store.get("team").id}`;
    },
  },
  created() {
    EventBus.$on("REPLACE_CONFIG", this.replace);
  },
  mounted() {
    if (!store.get("token")) {
      return;
    }

    this.updateConfig();
    this.listenPusherEvents();
  },
  beforeDestroy() {
    this.$pusher.unsubscribe(this.userChannelName);
    this.$pusher.unsubscribe(this.teamChannelName);
  },
  methods: {
    updateConfig() {
      this.updateUserConfig();
      this.updateTeamConfig();
    },
    listenPusherEvents() {
      installPusher();

      const userChannel = this.$pusher.subscribe(this.userChannelName);
      userChannel.bind("user.updated", this.update);

      const teamChannel = this.$pusher.subscribe(this.teamChannelName);
      teamChannel.bind("team.updated", this.update);
    },
    updateUserConfig() {
      return this.$http
        .get(`${jiminnyHost()}/api/v1/users/current`)
        .then((response) => this.update({ user: response.data }))
        .catch(console.error);
    },
    updateTeamConfig() {
      return this.$http
        .get(`${jiminnyHost()}/api/v1/organizations/current`)
        .then((response) => this.update({ team: response.data }))
        .catch(console.error);
    },
    update(partialData) {
      store.setBulk(partialData);
      const config = store.data();

      chrome.runtime.sendMessage(env("EXTENSION_ID"), {
        type: "JIMINNY.EXTENSION_APP.REPLACE_CONFIG",
        config,
      });

      initLogRocket();
    },
    replace(config) {
      store.init(config);

      chrome.runtime.sendMessage(env("EXTENSION_ID"), {
        type: "JIMINNY.EXTENSION_APP.REPLACE_CONFIG",
        config,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// sync-config.vue?754442ed